import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { yScaleModeAtom, unitAtom } from '@src/components/metrics-panel-hz/atoms';
import { VALUE_AXIS } from '../utils/constants';

const setMinMaxYAxis = (instance, shouldScale) => {
  instance.setOption({
    yAxis: {
      id: VALUE_AXIS,
      scale: shouldScale,
    },
  });
};

const useYAutoAxis = ({ instance, metric, enabled }) => {
  const yScaleMode = useAtomValue(yScaleModeAtom);
  const unit = useAtomValue(unitAtom);

  useEffect(() => {
    if (instance) {
      if (yScaleMode && enabled) {
        setMinMaxYAxis(instance, true);
      } else {
        setMinMaxYAxis(instance, false);
      }
    }
  }, [instance, yScaleMode, metric, unit, enabled]);
};

export default useYAutoAxis;
